import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { commonStrings } from '../../../../core';
import { SubscriptionStrings } from '../../../subscription/business';
import { PaymentOptionsEnum, PaymentOptionsIconEnum, PaymentOptionsStatusEnum } from '../../business/api';
import { PaymentData, PaymentStrings, PaymentSubscriptionData, SubscriptionPlanChosen, SubscriptionType } from '../../business/core';
import { PaymentOptionsFactoryImpl } from '../impl/factories';

export const initialPaymentData: PaymentSubscriptionData = {
    name: "",
    data: [],
    description: "",
    price: "",
    discount: ""
};

export const PaymentContent: React.FC<PaymentData> = ({ paymentData, subscriptionChosen, isToUpdate }) => {
    const [paymentChosen, setPaymentChosen] = useState<string>(PaymentOptionsEnum.BANK_SLIP);
    const chosenPlan: SubscriptionPlanChosen = { id: subscriptionChosen.id, frequency: subscriptionChosen.frequency, paymentMethod: paymentChosen }
    const paymentStrings = PaymentStrings['PTBR'];
    const subscriptionStrings = SubscriptionStrings['PTBR'].page.plans;
    const currencySymbol = commonStrings().PTBR.core.currency_symbol;
    const paymentIconsFactory = PaymentOptionsIconEnum;

    const factory = new PaymentOptionsFactoryImpl();

    const paymentOptions = Object.keys(PaymentOptionsEnum).map((option, index) => {
        return (
            <Col lg={2} md={3} sm={4} xs={4}>
                <Button
                    key={index}
                    variant={paymentChosen === PaymentOptionsEnum[option] ? "outline-primary" : "outline-secondary"}
                    style={{ width: '100%', height: 80, lineHeight: 1 }}
                    onClick={() => setPaymentChosen(PaymentOptionsEnum[option])}
                    disabled={PaymentOptionsStatusEnum[option] === 'disabled'}>
                    {paymentIconsFactory(PaymentOptionsEnum[option])} {paymentStrings.payment_options[PaymentOptionsEnum[option]].description}
                </Button>
            </Col>
        )
    })

    return (
        <div className={`font-poppins ${!isToUpdate ? `mt-5` : ``}`}>
            <Card>
                <Card.Body>
                    <Row>
                        <Col xs={5} sm={5} md={4} lg={3}>
                            <h1>{paymentStrings.title} {subscriptionStrings[paymentData.name].title}</h1>
                            <p style={{ marginBottom: -5 }}>{subscriptionStrings.data_labels.limit(paymentData.data[0])}</p>
                            <p>{subscriptionStrings.data_labels.titles[paymentData.data[1]]}</p>
                        </Col>
                        <Col xs={7} sm={7} md={8} lg={9}>
                            <p style={{ fontWeight: "bold" }}>{subscriptionStrings[paymentData.name].summary}</p>
                            <p style={{ fontWeight: "bold", fontSize: 24 }} className={"color-primary"}>
                                {currencySymbol} {paymentData.price}
                                <small style={{ fontSize: 12, color: 'black' }}>
                                    /{paymentStrings.frequency[subscriptionChosen.frequency]}
                                </small>
                            </p>
                            <p style={{ marginTop: -20 }}>{paymentData.discount}{PaymentStrings['PTBR'].discount}</p>
                        </Col>
                    </Row>
                </Card.Body>
                {paymentData.price !== "0,00" ?
                    <Card.Header>
                        <Row>
                            {paymentOptions}
                        </Row>
                    </Card.Header>
                    :
                    <></>
                }
                <Card.Body>
                    {!chosenPlan || !paymentChosen ? <Spinner /> : factory.create(paymentChosen, chosenPlan, isToUpdate, SubscriptionType.SUBSCRIPTION, paymentData.price === "0,00")}
                </Card.Body>
            </Card>
        </div>
    )
}